import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import PageHero from "../ones/PageHero";
import ServicesContent from "../ones/ServicesContent";
import Footer from "../ones/Footer";
import CallToAction from "../ones/callToAction";

export default function ServicesLanding() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      <PageHero
        title="Empowering Projects through Comprehensive Geospatial Services"
        description="From geo-location and land surveying to drone imaging and LiDAR, AGS brings together the field expertise and spatial technology needed for dependable project delivery."
        badge="Services"
      />
      <ServicesContent />
      <CallToAction />
      <Footer />
    </>
  );
}
